import { api } from './services';
import { DropdownList } from '../components/admin/dropdown-lists/store/types';

export const publishDropdownList = async (reqBody: DropdownList) => await api('dropdown-list/upsert', reqBody, 'post');

export const fetchAllDropdownLists = async () => await api('dropdown-list/all', {}, 'get');
